export default __webpack_public_path__ + "static/media/blue_lagoon_3_lowdef.abebe8dd.png";